import { Controller } from "@hotwired/stimulus"

// Site header: floating-card look once scrolled, and the mobile menu
export default class extends Controller {
  static targets = ["menu", "toggle"]

  connect() {
    this.onScroll = () => this.element.classList.toggle("is-stuck", scrollY > 8)
    addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    removeEventListener("scroll", this.onScroll)
  }

  toggle() {
    const open = this.menuTarget.hidden
    this.menuTarget.hidden = !open
    this.toggleTarget.setAttribute("aria-expanded", String(open))
  }

  close(event) {
    if (event.key === "Escape" || !this.element.contains(event.target)) {
      this.menuTarget.hidden = true
      this.toggleTarget.setAttribute("aria-expanded", "false")
    }
  }
}
